/* import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ReportDefinition} from '../domain/reportdefinition';
import { MessageService } from 'primeng/api';
import { Configuration } from '../domain/configuration';
import { IdName } from '../domain/idname';

@Injectable()
export class ReportDefinitionService {


    uri = '/api/report';

    uriProc = '/api/proc';

    constructor(private http: HttpClient, private messageService: MessageService) {}

    get(companyId : number) : Promise<ReportDefinition[]> {
        const promise = this.http.get<ReportDefinition[]>(`${this.apiUrl}${this.uriPath}/definitions/${companyId}`)
                          .toPromise();
        //promise.then(data => console.log('Report definitions: ' + JSON.stringify(data)));
        return promise;
    }

    getById(id: number) : Promise<ReportDefinition> {
        const promise = this.http.get<ReportDefinition>(`${this.apiUrl}${this.uriPath}/${id}`)
                          .toPromise();
        //promise.then(data => console.log('Report : ' + JSON.stringify(data)));
        return promise;
    }

    getFilterAccounts(reportId: number) : Promise<IdName[]>
    {
        return this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/${reportId}/getFilterAccounts`).toPromise();
    }

    post(obj: ReportDefinition) {
        obj.CompanyId =  JSON.parse(
            localStorage.getItem('currentCompany')
        ).id;

        const promise =  this.http
                           .post<ReportDefinition>(`${this.apiUrl}${this.uriPath}`, obj )
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Report created' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: error.error })
        });
        return promise;
    }

    clone(id : number) {

        const promise =  this.http
                           .post(`${this.apiUrl}${this.uriPath}/clone/${id}`, {})
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Duplicating successful: id=' + oa, detail: '' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Duplicating failed', detail: error.status + ':' + error.message })
        });
        return promise;
    }

    execute(ids : number[]) {

        const companyId =  JSON.parse(
            localStorage.getItem('currentCompany')
        ).id;

        const promise =  this.http
                           .post(`${this.apiUrl}${this.uriProcPath}/execute/${companyId}`, ids)
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Batch executed: id=' + oa, detail: '' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Batch execute failed', detail: error.status + ':' + error.message })
        });
        return promise;
    }

    executeStoredProcedure(procedureName : string) {
        const promise =  this.http
                           .post(`${this.apiUrl}${this.uriProcPath}/execute-stored-procedure/${procedureName}`, null)
                           .toPromise();
        promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Stored procedure ' + procedureName + ' successfully executed!' });
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Failed to execute stored procedure ' + procedureName + '!', detail: error.status + ':' + error.message });
        });
        return promise;
    }

    executeProcessReports(companyCode: string, reportCode: string) {
        const promise =  this.http
                           .get(`${this.apiUrl}${this.uriProcPath}/execute-process-reports/${companyCode}/${reportCode}`)
                           .toPromise();
        promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Process Reports successfully executed!' });
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Failed to execute Process Reports!', detail: error.status + ':' + error.message });
        });
        return promise;
    }

    put(obj: ReportDefinition, id: string) {
        const promise =  this.http
                           .put<ReportDefinition>(`${this.apiUrl}${this.uriPath}/${id}`, obj )
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Report updated' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: error.error })
        });
        return promise;
    }

    delete(id: string) {
        const promise =  this.http
                           .delete(`${this.apiUrl}${this.uriPath}/${id}`)
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Deletiing successful', detail: 'Report deleted' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Deleting failed', detail: error.status + ':' + error.message })
        });
        return promise;
    }
}
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReportDefinition } from '../domain/reportdefinition';
import { MessageService } from 'primeng/api';
import { DynamicBackendConfigService } from './dynamic-backend-config.service';
import { Observable } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';
import { IdName } from '../domain/idname';
import { AppConfigService } from './app-config.service';
import { Utils } from 'src/app/utilities/utils';

@Injectable()
export class ReportDefinitionService {

    private uriPath = '/api/report';
    private uriProcPath = '/api/proc';
    private uriValuesPath = '/api/values';
    uri = '';
    uriProc = ''

    apiUrl="";

    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private dynamicConfig: DynamicBackendConfigService,
        private appConfigService: AppConfigService
    ) {
        this.apiUrl = this.appConfigService.apiUrl;
       /* this.dynamicConfig.getApiUrl().subscribe(apiUrl => {
            this.uri = this.dynamicConfig.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
            this.uriProc = this.dynamicConfig.extractSecondURL(apiUrl ? `${apiUrl}${this.uriProcPath}` : this.uriProcPath);
          });
          */
    }
/* 
    get(companyId: number): Observable<ReportDefinition[]> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/definitions/${companyId}`;
                return this.http.get<ReportDefinition[]>(url);
            })
        );
    }

    getById(id: number): Observable<ReportDefinition> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${id}`;
                return this.http.get<ReportDefinition>(url);
            })
        );
    }

    getFilterAccounts(reportId: number): Observable<IdName[]> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${reportId}/getFilterAccounts`;
                return this.http.get<IdName[]>(url);
            })
        );
    }

    post(obj: ReportDefinition): Observable<ReportDefinition> {
        obj.CompanyId = JSON.parse(localStorage.getItem('currentCompany')).id;

        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}`;
                return this.http.post<ReportDefinition>(url, obj).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Saving successful',
                            detail: 'Report created',
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Saving failed',
                            detail: error.error,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    clone(id: number): Observable<any> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/clone/${id}`;
                return this.http.post(url, {}).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: `Duplicating successful: id=${id}`,
                            detail: '',
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Duplicating failed',
                            detail: `${error.status}:${error.message}`,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    execute(ids: number[]): Observable<any> {
        const companyId = JSON.parse(localStorage.getItem('currentCompany')).id;

        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriProcPath}/execute/${companyId}`;
                return this.http.post(url, ids).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Batch executed',
                            detail: `ids=${ids.join(',')}`,
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Batch execute failed',
                            detail: `${error.status}:${error.message}`,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    executeStoredProcedure(procedureName: string): Observable<any> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriProcPath}/execute-stored-procedure/${procedureName}`;
                return this.http.post(url, null).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: `Stored procedure ${procedureName} successfully executed!`,
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: 'error',
                            summary: `Failed to execute stored procedure ${procedureName}!`,
                            detail: `${error.status}:${error.message}`,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    executeProcessReports(companyCode: string, reportCode: string): Observable<any> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriProcPath}/execute-process-reports/${companyCode}/${reportCode}`;
                return this.http.get(url).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Process Reports successfully executed!',
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Failed to execute Process Reports!',
                            detail: `${error.status}:${error.message}`,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    put(obj: ReportDefinition, id: string): Observable<ReportDefinition> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${id}`;
                return this.http.put<ReportDefinition>(url, obj).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Saving successful',
                            detail: 'Report updated',
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Saving failed',
                            detail: error.error,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    delete(id: string): Observable<any> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${id}`;
                return this.http.delete(url).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Deletiing successful',
                            detail: 'Report deleted',
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Deleting failed',
                            detail: `${error.status}:${error.message}`,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    } */

    
    get(companyId : number) : Promise<ReportDefinition[]> {
        const promise = this.http.get<ReportDefinition[]>(`${this.apiUrl}${this.uriPath}/definitions/${companyId}`)
                          .toPromise();
        //promise.then(data => console.log('Report definitions: ' + JSON.stringify(data)));
        return promise;
    }

    getById(id: number) : Promise<ReportDefinition> {
        const promise = this.http.get<ReportDefinition>(`${this.apiUrl}${this.uriPath}/${id}`)
                          .toPromise();
        //promise.then(data => console.log('Report : ' + JSON.stringify(data)));
        return promise;
    }

    getFilterAccounts(reportId: number) : Promise<IdName[]>
    {
        return this.http.get<IdName[]>(`${this.apiUrl}${this.uriPath}/${reportId}/getFilterAccounts`).toPromise();
    }

    post(obj: ReportDefinition) {
        obj.CompanyId =  JSON.parse(
            localStorage.getItem('currentCompany')
        ).id;

        const promise =  this.http
                           .post<ReportDefinition>(`${this.apiUrl}${this.uriPath}`, obj )
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Report created' })
        })
        .catch(error => {
            
            this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: Utils.extractSQLError(error.error)})
        });
        return promise;
    }

    clone(id : number) {

        const promise =  this.http
                           .post(`${this.apiUrl}${this.uriPath}/clone/${id}`, {})
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Duplicating successful: id=' + oa, detail: '' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Duplicating failed', detail: Utils.extractSQLError(error.error) })
        });
        return promise;
    }

    copy(id : number,companyid : number) {

        const promise =  this.http
                           .post(`${this.apiUrl}${this.uriPath}/copy/${id}/${companyid}`, {})
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Copying successful: id=' + oa, detail: '' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Copying failed', detail: Utils.extractSQLError(error.error) })
        });
        return promise;
    }


    execute(ids : number[]) {

        const companyId =  JSON.parse(
            localStorage.getItem('currentCompany')
        ).id;

        const promise =  this.http
                           .post(`${this.apiUrl}${this.uriProcPath}/execute/${companyId}`, ids)
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Batch executed: id=' + oa, detail: '' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Batch execute failed', detail: Utils.extractSQLError(error.error)})
        });
        return promise;
    }

    executeStoredProcedure(procedureName : string) {
        const promise =  this.http
                           .post(`${this.apiUrl}${this.uriProcPath}/execute-stored-procedure/${procedureName}`, null)
                           .toPromise();
        promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Stored procedure ' + procedureName + ' successfully executed!' });
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Failed to execute stored procedure ' + procedureName + '!', detail: Utils.extractSQLError(error.error) });
        });
        return promise;
    }

    executeProcessReports(companyCode: string, reportCode: string) {
        const promise =  this.http
                           .get(`${this.apiUrl}${this.uriProcPath}/execute-process-reports/${companyCode}/${reportCode}`)
                           .toPromise();
        promise.then( oa => {
            this.messageService.add({ severity: 'success', summary: 'Process Reports successfully executed!' });
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Failed to execute Process Reports!', detail: Utils.extractSQLError(error.error) });
        });
        return promise;
    }

    put(obj: ReportDefinition, id: string) {
        const promise =  this.http
                           .put<ReportDefinition>(`${this.apiUrl}${this.uriPath}/${id}`, obj )
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Report updated' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Saving failed', detail: Utils.extractSQLError(error.error) })
        });
        return promise;
    }

    delete(id: string) {
        const promise =  this.http
                           .delete(`${this.apiUrl}${this.uriPath}/${id}`)
                           .toPromise();
        promise.then( oa => {
                this.messageService.add({ severity: 'success', summary: 'Deletiing successful', detail: 'Report deleted' })
        })
        .catch(error => {
            this.messageService.add({ severity: 'error', summary: 'Deleting failed', detail:  Utils.extractSQLError(error.error) })
        });
        return promise;
    }
    
}
